import React from "react";
import { Tag } from "antd";
import { FaCrown } from "react-icons/fa";
const PremiumTheme = ({ size, height, fontSize, float, marginLeft }) => {
  if (!height) {
    height = "32px";
  }
  if (!fontSize) {
    fontSize = "15px";
  }
  if (!float) {
    float = "right";
  }
  if (!marginLeft) {
    marginLeft = "0px";
  }
  return (
    <Tag
      color="#FDB62F"
      style={{
        float,
        fontSize,
        height,
        lineHeight: "32px",
        cursor: "pointer",
        marginLeft,
      }}
    >
      <FaCrown />
    </Tag>
  );
};

export default PremiumTheme;
